import React, { FC } from 'react'
import { testId } from '@lojinha/helpers'
import { Box, Text, Stack } from '@lojinha/design-system'
import { InsideProducts } from '../../../modules/page-content/page-content.types'
import { t } from '../../../dictionary'

type IngredientsProps = {
  allIngredients: InsideProducts[]
}

export const Ingredients: FC<IngredientsProps> = ({ allIngredients }) => {
  return (
    <Stack margin="x24" {...testId('marketable-product-ingredients')}>
      <Text isBrand textTransform="uppercase">
        {t.ingredients}
      </Text>
      {allIngredients.map((ingridentItem: InsideProducts) => (
        <Box key={ingridentItem.id}>
          <Text isBold>{ingridentItem.name}:</Text>
          <Text>{ingridentItem.ingredients}</Text>
        </Box>
      ))}
    </Stack>
  )
}
